import { FlyoutMenu as FlyoutMenuBase } from "@omni/components/components/Navigation/FlyoutMenu/flyoutMenu";

import { FlyoutMenuComponent } from "@/components/Navigation/FlyoutMenu/flyoutMenu.component";

export const FlyoutMenu = () => {
    return (
        <FlyoutMenuBase>
            <FlyoutMenuComponent />
        </FlyoutMenuBase>
    );
};
